import { AxiosError } from "axios";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

import { rxErrorFetchingData, rxSuccessFetchingData, rxStartFetching } from "./attendTickets.slice";
import { axiosApiService } from "../../services/axiosApi.service";
import { AttendTicketsFilterRequest } from "../../../types/request/ticket.request.type";
import { HelpDeskApiRoutes } from "../../../utils/mapping/apiRoutes.mapping";

export const getAttendTickets = (params: AttendTicketsFilterRequest) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    dispatch(rxStartFetching());
    const { data } = await axiosApiService().get(HelpDeskApiRoutes.attendTickets, { params: params });
    dispatch(rxSuccessFetchingData(data));
  } catch (error) {
    const err = error as AxiosError;
    dispatch(rxErrorFetchingData(err.message));
  }
};
